import { IconType } from "@/types/icons";

const DEFAULT_PATH = "/icons/";
const SVG = ".svg";

export const getIconPath = (iconName: IconType): string =>
  DEFAULT_PATH + iconName + SVG;
